import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { BaseDialogComponent } from '@cumlaude/shared-components-dialogs';
import { IconComponent } from '@cumlaude/shared-components-icons';
import { SortDirection } from '../../../shared/components/table/table/table.component';

@Component({
	selector: 'app-groepering-sorteren-dialog',
	templateUrl: './groepering-sorteren-dialog.component.html',
	styleUrls: ['./groepering-sorteren-dialog.component.scss'],
	imports: [BaseDialogComponent, IconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroeperingSorterenDialogComponent {
	protected dialogRef = inject<DialogRef<SortDirection>>(DialogRef);
}
